import type { InjectionKey, Ref } from 'vue';

/** Exposed API from FasletCustomButton — used by ShopwareFasletWidget callbacks. */
export interface FasletCustomButtonApi {
    handleButtonShow: () => void;
    handleButtonHidden: () => void;
    handleResult: (result: { label: string }, resultType: 'auto' | 'result-screen') => void;
    /** Re-syncs the CTA label when the Faslet profile changes; resets to the default snippet when data is cleared. */
    handleDataChanged: (data: { profile?: unknown }) => void;
}

export const fasletCustomButtonInjectionKey: InjectionKey<Ref<FasletCustomButtonApi | null>> =
    Symbol('fasletCustomButton');

export function provideFasletCustomButtonTarget() {
    const target = ref<FasletCustomButtonApi | null>(null);
    provide(fasletCustomButtonInjectionKey, target);
    return target;
}

export function useFasletCustomButtonTarget() {
    return inject(fasletCustomButtonInjectionKey, null);
}
